/**
 * Refactor by liuxiangyang on 2025/5/27.
 */
/* eslint-disable no-unused-vars */
import moment from 'moment';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import Icon from '../../wui-icon/src';
import { getOptions } from './_utils/headerSelect';
import { _PREFIX_CLS } from './DatePicker';

const DatePickerHeaderSelect = React.forwardRef<any, any>((props) => {
    let yearUl = useRef<HTMLDivElement | null>(null);
    let monthUl = useRef<HTMLDivElement | null>(null);
    let headerNode = useRef<any>(null);

    const {picker, lang, fieldid, position, onPanelshow, hiddenHandleSelect, defaultValue, getDiffValueHandle, direction, now} = props;

    const nowYear = now.year();
    const nowMonth = now.month() + 1;
    const options = useMemo(() => getOptions(picker, direction), [picker, direction]);

    // @ts-ignore
    const [diffValue, setDiffValue] = useState([0, 0]);
    // @ts-ignore
    const [selectYear, setSelectYear] = useState<number | string>(nowYear);
    const [selectMonth, setSelectMonth] = useState(nowMonth);
    const [maskShow, setMaskShow] = useState(false);
    const [activeYearNum, setActiveYearNum] = useState(0);
    const [activeMonthNum, setActiveMonthNum] = useState(0);
    const [currentYear, setCurrentYear] = useState(0);
    const [currentMonth, setCurrentMonth] = useState(0);
    const [changeYear, setChangeYear] = useState(nowYear);

    // --------- ⬇️⬇️⬇️⬇️ 原ComponentWillReceiveProps逻辑 start ⬇️⬇️⬇️⬇️----------
    useEffect(() => {
        if ('value' in props && !('valueLeft' in props) && props.value != '') {
            if (!picker || picker === 'date' || picker === 'week') {
                if (!props.value) {
                    setSelectYear(nowYear)
                    setSelectMonth(nowMonth)
                } else {
                    let dateArr = props?.value?.split(/\s+/);
                    if (parseInt(dateArr[1]) === 12) {
                        setSelectYear(parseInt(dateArr[0]) + 1)
                        setSelectMonth(1)
                        setChangeYear(parseInt(dateArr[0]) + 1);
                    } else {
                        setSelectYear(parseInt(dateArr[0]))
                        setSelectMonth(parseInt(dateArr[1]) + 1)
                        setChangeYear(parseInt(dateArr[0]));
                    }
                }
            } else if (picker === 'month' || picker === 'quarter' || picker === 'halfYear') {
                setSelectYear(parseInt(props.value))
                setSelectMonth(0)
            } else if (picker === 'year') {
                setSelectYear(parseInt(props.value))
                setSelectMonth(0)
            }
        }
        if ('valueLeft' in props && !('value' in props) && props.valueLeft != '') {
            if (!picker || picker === 'date' || picker === 'week') {
                if (!props.valueLeft) {
                    setSelectYear(nowYear)
                    setSelectMonth(nowMonth)
                } else {
                    let dateArr = props?.valueLeft?.split(/\s+/);
                    if (parseInt(dateArr[1]) === 1) {
                        setSelectYear(parseInt(dateArr[0]) - 1)
                        setSelectMonth(12)
                    } else {
                        setSelectYear(parseInt(dateArr[0]))
                        setSelectMonth(parseInt(dateArr[1]) - 1)
                    }
                }
            } else if (picker === 'month' || picker === 'quarter' || picker === 'halfYear') {
                setSelectYear(parseInt(props.valueLeft))
                setSelectMonth(0)
            } else if (picker === 'year') {
                setSelectYear(parseInt(props.valueLeft))
                setSelectMonth(0)
            }
        }
    }, [props.value, props.valueLeft, picker])

    // @ts-ignore
    const inputBlur = (val: boolean) => {
        setMaskShow(val)
    };

    // 选择cascader之后，联动日期面板
    const onCascaderChange = (val: any, flag: string) => {
        let differenceYear = 0
        let differenceMonth = 0
        if (!picker || picker === 'date' || picker === 'week') {
            differenceYear = parseInt(val[0]) - currentYear
            differenceMonth = parseInt(val[1]) - currentMonth
            if (flag && flag === 'monthFlag') {
                differenceYear = 0
            } else if (flag && flag === 'yearFlag') {
                differenceMonth = 0
            }
            setSelectYear(parseInt(val[0]))
            setSelectMonth(parseInt(val[1]))
            getDiffValueHandle?.({
                value: [differenceYear, differenceMonth],
                val: parseInt(val[0]) + '年' + ' ' + parseInt(val[1]) + '月',
                ismask: false,
                position,
                flag
            })
        } else if (picker === 'month' || picker === 'quarter' || picker === 'halfYear') {
            differenceYear = parseInt(val[0]) - currentYear
            differenceMonth = 0
            setSelectYear(parseInt(val[0]))
            getDiffValueHandle?.({
                value: [differenceYear, differenceMonth],
                val: parseInt(val[0]) + '年',
                ismask: false,
                position
            })
        } else if (picker === 'year') {
            const _currentYear = parseInt("" + currentYear)
            differenceYear = (parseInt(val[0].slice(0, 4)) - _currentYear) / 10
            differenceMonth = 0
            setSelectYear(parseInt(val[0]))
            getDiffValueHandle?.({
                value: [differenceYear, differenceMonth],
                val: val[0],
                ismask: false,
                position
            })
        }
        setDiffValue([differenceYear, differenceMonth]) // 联动选择值之后让日历面板跳转到相应的年月，传入@tinper/rc-picker
    }

    // 点击年份
    const onChangeYear = (val: string, index: number) => {
        if (!picker || picker === 'date' || picker === 'week') {
            setSelectYear(parseInt(val))
            setCurrentYear(parseInt(val))
            setChangeYear(parseInt(val));
        } else if (['month', 'quarter', 'halfYear'].includes(picker)) {
            setMaskShow(false)
            setSelectYear(parseInt(val))
        } else if (picker === 'year') {
            setMaskShow(false)
            setSelectYear(val)
        }
        setActiveYearNum(index)

        let newArr = [val, selectMonth];
        onCascaderChange(newArr, 'yearFlag');
    };

    // 点击月份
    // @ts-ignore
    const onChangeMonth = (monthValue: string, index: number) => {
        setMaskShow(false)
        setSelectMonth(index + 1)
        setActiveMonthNum(index)
        let newArr = null;
        if (!picker || picker === 'date' || picker === 'week') {
            let headernode = parseInt(
                headerNode.current?.parentNode.parentNode.querySelector(`.${_PREFIX_CLS}-year-btn`)?.textContent
            );
            newArr = [headernode, index + 1];
        } else {
            newArr = [changeYear, index + 1];
        }
        onCascaderChange(newArr, 'monthFlag');
    }

    const clickValue = (e: any) => {
        setMaskShow(!maskShow)
        const parentNode = e.target.parentNode.parentNode
        let currentYear = parseInt(
            parentNode.querySelector(`.${_PREFIX_CLS}-${picker === 'year' ? 'decade' : 'year'}-btn`)?.textContent
        );
        let currentMonth = parentNode.querySelector(`.${_PREFIX_CLS}-month-btn`)?.textContent;
        options.map((item, index) => {
            if (picker === 'year') {
                // picker为年时以10年为单位
                let currentYearRang =
                    parentNode.querySelector(`.${_PREFIX_CLS}-decade-btn`).textContent;
                if (item.label === currentYearRang) {
                    setActiveYearNum(index)
                }
            } else {
                if (parseInt(item.label) === currentYear) {
                    setActiveYearNum(index)
                }
            }
        });
        moment.locale(lang.lang);
        let monthArr = lang.langMap?.monthsShort || moment.localeData().monthsShort();

        // @ts-ignore
        monthArr.map((item: any, index: number) => {
            if (currentMonth === item) {
                setActiveMonthNum(index)
            }
        });
        onPanelshow?.(maskShow, position);
        // 添加默认值是计算selectYear、selectMonth
        if (defaultValue && position === 'left') {
            setSelectYear(moment(defaultValue[0])?.year())
            setSelectMonth(moment(defaultValue[0])?.month() + 1)
        }
        if (defaultValue && position === 'right') {
            setSelectYear(moment(defaultValue[1])?.year())
            setSelectMonth(moment(defaultValue[1])?.month() + 1)
        }
        if (!picker || picker === 'date' || picker === 'week') {
            monthArr.find((item: any, index: number) => {
                if (currentMonth === item) {
                    currentMonth = index + 1
                }
            }); // bugfix QDJCJS-14150 英文环境下，期间选择月，选不上; 字符串Jul ==> 7
            setCurrentYear(currentYear)
            setCurrentMonth(currentMonth)
        } else if (picker === 'month' || picker === 'quarter' || picker === 'halfYear') {
            setCurrentYear(currentYear)
        } else if (picker === 'year') {
            let currentYearRang = parentNode.querySelector(
                `.${_PREFIX_CLS}-decade-btn`
            ).textContent;
            setCurrentYear(currentYearRang)
        }
        // rangpicker 下拉不同时展开
        if (maskShow) {
            hiddenHandleSelect?.(position);
        }
    };

    const scrollToActive = useCallback(() => {
        // 每次面板展开选中项在面板中间
        let liDom = document.querySelectorAll(`.${_PREFIX_CLS}-header-select-year li`)[0]
        let liHeight = liDom?.getBoundingClientRect()?.height
        if (yearUl.current && liHeight) {
            yearUl.current.scrollTop = (activeYearNum - 2) * liHeight;
        }
        if (monthUl.current && liHeight) {
            monthUl.current.scrollTop = (activeMonthNum - 2) * liHeight;
        }
    }, [activeYearNum, activeMonthNum])

    // --------- ⬇️⬇️⬇️⬇️ 原setTimeout逻辑 start ⬇️⬇️⬇️⬇️----------
    useLayoutEffect(() => {
        scrollToActive()
    }, [maskShow])

    // --------- ⬇️⬇️⬇️⬇️ 原render逻辑 start ⬇️⬇️⬇️⬇️----------
    const monthData = useMemo(() => {
        moment.locale(lang.lang);
        return lang.langMap?.monthsShort || moment.localeData().monthsShort();
    }, [lang.lang]);

    const node = (
        <div className={`${_PREFIX_CLS}-header-select`}>
            <div className={`${_PREFIX_CLS}-header-select-year`} ref={yearUl}>
                <ul>
                    {options.map((item, index) => {
                        return (
                            <li
                                className={
                                    activeYearNum == index
                                        ? `${_PREFIX_CLS}-header-select-year-active`
                                        : undefined
                                }
                                key={item.value + index}
                                {...(fieldid ? {fieldid: `${fieldid}_year_${parseInt(item.label)}`} : {})}
                                onClick={() => onChangeYear(item.label, index)}
                            >
                                {lang.lang === 'zh-cn' || lang.lang === 'zh-tw'
                                    ? picker != 'year'
                                        ? activeYearNum == index
                                            ? parseInt(item.label) + ' 年'
                                            : parseInt(item.label)
                                        : item.label
                                    : picker != 'year'
                                        ? parseInt(item.label)
                                        : item.label}
                            </li>
                        );
                    })}
                </ul>
            </div>
            {options[0]?.children && (
                <div className={`${_PREFIX_CLS}-header-select-month`} ref={monthUl}>
                    <ul>
                        {Array.isArray(monthData) && monthData?.map((item: string, index: number) => {
                            return (
                                <li
                                    className={
                                        activeMonthNum == index
                                            ? `${_PREFIX_CLS}-header-select-month-active`
                                            : undefined
                                    }
                                    key={item + index}
                                    {...(fieldid ? {fieldid: `${fieldid}_month_${index + 1}`} : {})}
                                    onClick={() => onChangeMonth(item, index)}
                                >
                                    {lang.lang === 'zh-cn' || lang.lang === 'zh-tw' ? parseInt(item) : item}
                                    {lang.lang === 'zh-cn' || lang.lang === 'zh-tw'
                                        ? activeMonthNum == index
                                            ? ' 月'
                                            : ''
                                        : ''}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );

    const iconNode = (
        <div className={`${_PREFIX_CLS}-header-select-icon`}>
            {maskShow ? <Icon type='uf-gridcaretarrowup' /> : <Icon type='uf-gridcaretdown' />}
        </div>
    );

    return (
        <>
            {iconNode}
            <div className={`${_PREFIX_CLS}-header-select-box`}>
                {maskShow && node}
                <div
                    ref={headerNode}
                    style={{background: 'transparent', height: '100%'}}
                    onClick={clickValue}
                    {...(fieldid ? {fieldid: `${fieldid}_${position}-header-select`} : {})}
                >
                    {' '}
                </div>
            </div>
        </>
    );
})

export default DatePickerHeaderSelect;
